import React from 'react'
import { List, ListItem, ListItemText } from '@mui/material'
import { RemoveProjectResourceAction, SetResourceAsProjectCoverAction } from '../..'
import { useResolveComponentData } from '../../../local'
import { get } from 'lodash'

import '../ListMenu.scss'

/**
 * @typedef {Object} ResourceMenuProps
 * @property {string} defaultResourceType
 * @property {string} defaultResourceId
 * @property {string} defaultProjectId
 */

/**
 * Project resource contextual menu.
 * @return {JSX.Element}
 */
export const ResourceMenu = ({
  defaultResourceType = 'product',
  defaultResourceId = '24',
  defaultProjectId = '32',
}) => {
  const { jsElementRef, jsComponentData } = useResolveComponentData({
    containerType: 'resource',
    attributeNames: ['data-resource-type', 'data-resource-id'],
  })
  const finalResourceType = get(jsComponentData, 'data-resource-type', defaultResourceType)
  const finalResourceId = get(jsComponentData, 'data-resource-id', defaultResourceId)
  const finalProjectId = get(window || {}, 'drupalSettings.react.currentNodeId', defaultProjectId)

  return (
    <List ref={jsElementRef} dense disablePadding>
      <ListItem disablePadding>
        <ListItemText>
          <SetResourceAsProjectCoverAction
            resourceType={finalResourceType}
            resourceId={finalResourceId}
            projectId={finalProjectId}
          />
        </ListItemText>
      </ListItem>
      <ListItem disablePadding>
        <ListItemText>
          <RemoveProjectResourceAction
            resourceType={finalResourceType}
            resourceId={finalResourceId}
            projectId={finalProjectId}
          />
        </ListItemText>
      </ListItem>
    </List>
  )
}
